
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("53kS0", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2Fndw = parcelRequire("2Fndw");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $1uFM6 = parcelRequire("1uFM6");


var $7LI3Q = parcelRequire("7LI3Q");


var $7Sm4c = parcelRequire("7Sm4c");


var $dPJCf = parcelRequire("dPJCf");


var $1ytiN = parcelRequire("1ytiN");


var $8Lx5S = parcelRequire("8Lx5S");


var $d0oNo = parcelRequire("d0oNo");




// A component that opens the modal when the user is eligible




var $jmjWc = parcelRequire("jmjWc");







const $e1007dabeeee123f$export$9e44b2252d24bdda = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).FLYWHEEL_ACTIVATION
})(({ onClose: onClose, onInteraction: onInteraction, source: source })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e1007dabeeee123f$var$LazyModal, {
        onClose: onClose,
        onInteraction: onInteraction,
        transactional: false,
        source: source
    });
});

const $e1007dabeeee123f$var$LazyModal = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "bhEVC",
    name: "LazyModal",
    loader: async ()=>(await (parcelRequire("hpVzJ"))).Modal
});






var $evORK = parcelRequire("evORK");


var $hAauA = parcelRequire("hAauA");


var $7S7nY = parcelRequire("7S7nY");





var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $cOrQJ = parcelRequire("cOrQJ");


var $fpGTa = parcelRequire("fpGTa");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $inPa6 = parcelRequire("inPa6");


var $lsxnT = parcelRequire("lsxnT");





var $5Mdl1 = parcelRequire("5Mdl1");


var $jYnGA = parcelRequire("jYnGA");

var $91f926f384a15b44$exports = {};
$91f926f384a15b44$exports = new URL("nav4GlobalSpotlightImage.b0eee534.svg", import.meta.url).toString();


var $bacb838f87080dd0$exports = {};
$bacb838f87080dd0$exports = new URL("nav4GlobalSpotlightImageDark.46829a6e.svg", import.meta.url).toString();


var $14489a77f09b0793$exports = {};
$14489a77f09b0793$exports = new URL("nav4SpaceSpotlightImage.8dc1626b.svg", import.meta.url).toString();


var $c6cd114591589735$exports = {};
$c6cd114591589735$exports = new URL("nav4SpaceSpotlightImageDark.eeaa5b5d.svg", import.meta.url).toString();


const $94119d6b2f3cf2b8$var$COMMUNITY_POST_LINK = 'https://support.atlassian.com/navigation/docs/what-is-the-new-navigation-in-confluence/';
const $94119d6b2f3cf2b8$var$NAV4_GLOBAL_SPOTLIGHT_SOURCE = 'nav4GlobalSpotlight';
const $94119d6b2f3cf2b8$var$Nav4GlobalSpotlight = ({ onNext: onNext, onBack: onBack, onDismiss: onDismiss, progress: progress, messageType: messageType = 'engagement' })=>{
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const isDarkMode = colorMode === 'dark';
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { actions: actions, actionsBeforeElement: actionsBeforeElement } = (0, $jYnGA.useSpotlightActions)({
        progress: progress,
        onNext: onNext,
        onBack: onBack,
        source: $94119d6b2f3cf2b8$var$NAV4_GLOBAL_SPOTLIGHT_SOURCE
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d0oNo.WithModernizeNav4GlobalChangeboardingActive), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Spotlight, {
        actions: actions,
        actionsBeforeElement: actionsBeforeElement,
        dialogPlacement: "right top",
        dialogWidth: 338,
        heading: formatMessage($94119d6b2f3cf2b8$var$globalSpotlight.heading),
        headingAfterElement: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Mdl1.CrossIconCloseButton), {
            onClose: onDismiss,
            source: $94119d6b2f3cf2b8$var$NAV4_GLOBAL_SPOTLIGHT_SOURCE
        }),
        image: isDarkMode ? (0, (/*@__PURE__*/$parcel$interopDefault($bacb838f87080dd0$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($91f926f384a15b44$exports))),
        messageId: "nav4-spotlight-0",
        messageType: messageType,
        shouldWatchTarget: true,
        target: "nav4-spotlight-0",
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        targetRadius: 4
    }, formatMessage($94119d6b2f3cf2b8$var$globalSpotlight.body, {
        a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fpGTa.default), {
                onClick: ()=>{
                    createAnalyticsEvent({
                        type: 'sendUIEvent',
                        data: {
                            source: $94119d6b2f3cf2b8$var$NAV4_GLOBAL_SPOTLIGHT_SOURCE,
                            action: 'clicked',
                            actionSubject: 'link',
                            actionSubjectId: 'exploreNav4'
                        }
                    }).fire();
                },
                href: $94119d6b2f3cf2b8$var$COMMUNITY_POST_LINK,
                target: "_blank",
                xcss: $94119d6b2f3cf2b8$var$linkStyles
            }, chunks)
    })));
};
const $94119d6b2f3cf2b8$var$Nav4CollapseSpotlight = ({ onNext: onNext, onBack: onBack, onDismiss: onDismiss, progress: progress, messageType: messageType = 'engagement' })=>{
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { actions: actions, actionsBeforeElement: actionsBeforeElement } = (0, $jYnGA.useSpotlightActions)({
        progress: progress,
        onNext: onNext,
        onBack: onBack,
        source: 'nav4CollapseSpotlight'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Spotlight, {
        actions: actions,
        actionsBeforeElement: actionsBeforeElement,
        dialogPlacement: "right top",
        dialogWidth: 338,
        heading: formatMessage($94119d6b2f3cf2b8$var$collapseSpotlight.heading),
        headingAfterElement: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Mdl1.CrossIconCloseButton), {
            onClose: onDismiss,
            source: "nav4CollapseSpotlight"
        }),
        messageId: "nav4-spotlight-1",
        messageType: messageType,
        shouldWatchTarget: true,
        target: "nav4-spotlight-1",
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        targetRadius: 4
    }, formatMessage($94119d6b2f3cf2b8$var$collapseSpotlight.body));
};
const $94119d6b2f3cf2b8$var$Nav4SpaceSettingsSpotlight = ({ onNext: onNext, onBack: onBack, onDismiss: onDismiss, progress: progress, messageType: messageType = 'engagement' })=>{
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const isDarkMode = colorMode === 'dark';
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { actions: actions, actionsBeforeElement: actionsBeforeElement } = (0, $jYnGA.useSpotlightActions)({
        progress: progress,
        onNext: onNext,
        onBack: onBack,
        source: 'nav4SpaceSettingsSpotlight'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d0oNo.WithModernizeNav4SpaceSettingsChangeboardingActive), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Spotlight, {
        actions: actions,
        actionsBeforeElement: actionsBeforeElement,
        dialogPlacement: "right top",
        dialogWidth: 338,
        heading: formatMessage($94119d6b2f3cf2b8$var$spaceSettingsSpotlight.heading),
        headingAfterElement: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Mdl1.CrossIconCloseButton), {
            onClose: onDismiss,
            source: "nav4SpaceSettingsSpotlight"
        }),
        image: isDarkMode ? (0, (/*@__PURE__*/$parcel$interopDefault($c6cd114591589735$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($14489a77f09b0793$exports))),
        messageId: "nav4-spotlight-2",
        messageType: messageType,
        shouldWatchTarget: true,
        target: "nav4-spotlight-2",
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        targetRadius: 4
    }, formatMessage($94119d6b2f3cf2b8$var$spaceSettingsSpotlight.body, {
        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                weight: "bold"
            }, chunks)
    })));
};
const $94119d6b2f3cf2b8$var$linkStyles = (0, $ecnYn.xcss)({
    color: 'color.text.inverse',
    textDecoration: 'underline',
    ':hover': {
        color: 'color.text.inverse'
    },
    ':visited': {
        color: 'color.text.inverse',
        textDecoration: 'underline'
    },
    ':active': {
        color: 'color.text.inverse',
        textDecoration: 'underline'
    },
    ':focus': {
        color: 'color.text.inverse',
        textDecoration: 'underline'
    },
    ':visited:active': {
        color: 'color.text.inverse',
        textDecoration: 'underline'
    }
});
const $94119d6b2f3cf2b8$var$globalSpotlight = (0, $cgtv4.defineMessages)({
    heading: {
        id: "modernize-changeboarding.nav4-global-spotlight.heading",
        defaultMessage: "Find everything you need in the sidebar"
    },
    body: {
        id: "modernize-changeboarding.nav4-global-spotlight.body",
        defaultMessage: "Parts of the <a>navigation</a> have moved to the sidebar, which you can customize to your unique needs. "
    }
});
const $94119d6b2f3cf2b8$var$collapseSpotlight = (0, $cgtv4.defineMessages)({
    heading: {
        id: "modernize-changeboarding.nav4-collapse-spotlight.heading",
        defaultMessage: "Show or hide the sidebar"
    },
    body: {
        id: "modernize-changeboarding.nav4-collapse-spotlight.body",
        defaultMessage: "Select this icon to expand or collapse the sidebar."
    }
});
const $94119d6b2f3cf2b8$var$spaceSettingsSpotlight = (0, $cgtv4.defineMessages)({
    heading: {
        id: "modernize-changeboarding.nav4-space-settings-spotlight.heading",
        defaultMessage: "Quick access to settings and more"
    },
    body: {
        id: "modernize-changeboarding.nav4-space-settings-spotlight.body",
        defaultMessage: "Find <strong>Space settings</strong> in <strong>More actions</strong> (<strong>\u2022\u2022\u2022</strong>), where you can manage permissions, access, and content, and access Premium features."
    }
});
const $94119d6b2f3cf2b8$export$c7b90ff96148d0e3 = {
    Nav4GlobalSpotlight: $94119d6b2f3cf2b8$var$Nav4GlobalSpotlight,
    Nav4CollapseSpotlight: $94119d6b2f3cf2b8$var$Nav4CollapseSpotlight,
    Nav4SpaceSettingsSpotlight: $94119d6b2f3cf2b8$var$Nav4SpaceSettingsSpotlight
};


const $9a3235c67e6e7da5$export$8cd6411811444988 = ()=>{
    const { loading: aifcLoading, error: aifcError, isAIFCOnbardingEligible: isAIFCOnbardingEligible } = (0, $evORK.useIsAIFCOnbardingEligible)();
    const { loading: hasSeenChangeboardingLoading, error: hasSeenChangeboardingError, hasNotSeenGlobalNav4Changeboarding: hasNotSeenGlobalNav4Changeboarding } = $9a3235c67e6e7da5$export$5860d7af3254dd8d();
    const { completeNav4GlobalSpotlight: completeNav4GlobalSpotlight } = (0, $hAauA.useSetModernizeChangeboardingOnboardingState)();
    const isOnAnySettingsRoute = (0, $dPJCf.useRouteUrl)($9a3235c67e6e7da5$var$isOnAnySettingsRouteSelector);
    const showNav4GlobalSpotlight = !isAIFCOnbardingEligible && hasNotSeenGlobalNav4Changeboarding && !isOnAnySettingsRoute;
    if (hasSeenChangeboardingLoading || aifcLoading) return {
        steps: [],
        onComplete: ()=>{},
        loading: true
    };
    const error = hasSeenChangeboardingError || aifcError;
    if (error) return {
        steps: [],
        onComplete: ()=>{},
        error: error
    };
    if (!showNav4GlobalSpotlight) return {
        steps: [],
        onComplete: ()=>{}
    };
    const steps = [
        (0, $94119d6b2f3cf2b8$export$c7b90ff96148d0e3).Nav4GlobalSpotlight
    ];
    return {
        stepsToComplete: [
            (0, $hAauA.STEPS).NAV_4_GLOBAL
        ],
        steps: steps,
        onComplete: completeNav4GlobalSpotlight
    };
};
const $9a3235c67e6e7da5$export$5860d7af3254dd8d = ()=>{
    const { loading: onboardingLoading, error: onboardingError, isNav4GlobalSpotlightDismissed: isNav4GlobalSpotlightDismissed } = (0, $hAauA.useGetModernizeChangeboardingOnboardingState)();
    const { loading: tapLoading, error: tapError, isInNav4Audience: isInNav4Audience, hasDismissedNav4ChangeboardingViaEP: hasDismissedNav4ChangeboardingViaEP } = (0, $7S7nY.useModernizeChangeboardingTapTraits)();
    const loading = onboardingLoading || tapLoading;
    return {
        loading: loading,
        error: onboardingError || tapError,
        hasNotSeenGlobalNav4Changeboarding: !loading && isInNav4Audience && !isNav4GlobalSpotlightDismissed && !hasDismissedNav4ChangeboardingViaEP
    };
};
const $9a3235c67e6e7da5$var$isOnAnySettingsRouteSelector = {
    selector: (routeUrl)=>{
        if (!routeUrl) return false;
        return /\/wiki\/spaces\/[^/]+\/settings|\/wiki\/admin/.test(routeUrl);
    }
};















const $e2aaea8c229dc7c5$export$6d09c0166ca245c8 = ()=>{
    const { loading: aifcLoading, error: aifcError, isAIFCOnbardingEligible: isAIFCOnbardingEligible } = (0, $evORK.useIsAIFCOnbardingEligible)();
    const { loading: onboardingLoading, error: onboardingError, isNav4SpaceTourDismissed: isNav4SpaceTourDismissed } = (0, $hAauA.useGetModernizeChangeboardingOnboardingState)();
    const { loading: tapLoading, error: tapError, isInNav4Audience: isInNav4Audience, hasDismissedNav4ChangeboardingViaEP: hasDismissedNav4ChangeboardingViaEP } = (0, $7S7nY.useModernizeChangeboardingTapTraits)();
    const { completeNav4SpaceTour: completeNav4SpaceTour } = (0, $hAauA.useSetModernizeChangeboardingOnboardingState)();
    const isOnNonSettingsSpaceRoute = (0, $dPJCf.useRouteUrl)($e2aaea8c229dc7c5$var$isOnNonSettingsSpaceRouteSelector);
    const showNav4SpaceTour = !isAIFCOnbardingEligible && isOnNonSettingsSpaceRoute && isInNav4Audience && !hasDismissedNav4ChangeboardingViaEP && !isNav4SpaceTourDismissed;
    const loading = onboardingLoading || tapLoading || aifcLoading;
    const error = onboardingError || tapError || aifcError;
    if (loading) return {
        steps: [],
        onComplete: ()=>{},
        loading: true
    };
    if (error) return {
        steps: [],
        onComplete: ()=>{},
        error: error
    };
    if (!showNav4SpaceTour) return {
        steps: [],
        onComplete: ()=>{}
    };
    const steps = [
        (0, $94119d6b2f3cf2b8$export$c7b90ff96148d0e3).Nav4CollapseSpotlight,
        (0, $94119d6b2f3cf2b8$export$c7b90ff96148d0e3).Nav4SpaceSettingsSpotlight
    ];
    return {
        stepsToComplete: [
            (0, $hAauA.STEPS).NAV_4_SPACE
        ],
        steps: steps,
        onComplete: completeNav4SpaceTour
    };
};
const $e2aaea8c229dc7c5$var$isOnNonSettingsSpaceRouteSelector = {
    selector: (routeUrl)=>{
        if (!routeUrl) return false;
        return /\/wiki\/spaces\/[^/]+(\/(?!settings).*)?$/.test(routeUrl);
    }
};






var $3jwuS = parcelRequire("3jwuS");


var $ep3mz = parcelRequire("ep3mz");

/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $j1Ss3 = parcelRequire("j1Ss3");

const $50a0a148345476ba$export$cdd86cf5fc73d613 = (contentId)=>{
    const { data: data, loading: loading, error: error, refetch: refetch, networkStatus: networkStatus } = (0, $j1Ss3.useQuery)((0, $eSUdr.default)`query usePermissionCheckPermissionCheckContentQuery($contentId:ID!){content(id:$contentId){nodes{id type operations{operation targetType}}}}`, {
        skip: !contentId,
        variables: {
            contentId: contentId ?? ''
        },
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'cache-and-network'
    });
    const contentNode = data?.content?.nodes?.[0];
    const operations = contentNode?.operations ?? [];
    const contentType = contentNode?.type ?? undefined;
    const editPermission = operations.some((operationResults)=>operationResults?.operation === 'update' && operationResults?.targetType === contentType);
    return {
        canEdit: editPermission,
        loading: loading,
        contentQueryError: error,
        refetch: refetch,
        networkStatus: networkStatus
    };
};






var $47zp4 = parcelRequire("47zp4");

const $a50d2ca88e96f1cb$export$c068ac5463604183 = ()=>{
    const { loading: loading, error: error, hasDismissedLiveDocTour: hasDismissedLiveDocTour, hasDismissedConvertToPageSpotlight: hasDismissedConvertToPageSpotlight } = (0, $hAauA.useGetModernizeChangeboardingOnboardingState)();
    const { completeSegments: completeSegments } = (0, $hAauA.useSetModernizeChangeboardingOnboardingState)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { canEdit: canEdit, loading: contentQueryLoading, contentQueryError: contentQueryError } = (0, $50a0a148345476ba$export$cdd86cf5fc73d613)(contentId);
    const showConvertToPageSpotlight = !hasDismissedConvertToPageSpotlight && canEdit;
    const steps = (0, $42omo.useMemo)(()=>[
            ...!hasDismissedLiveDocTour ? [
                (0, $47zp4.Spotlights).ShareMenuSpotlight
            ] : [],
            ...showConvertToPageSpotlight ? [
                (0, $47zp4.Spotlights).ConvertToPageSpotlight
            ] : []
        ], [
        hasDismissedLiveDocTour,
        showConvertToPageSpotlight
    ]);
    const stepsToComplete = (0, $42omo.useMemo)(()=>{
        const keys = [];
        if (!hasDismissedLiveDocTour) keys.push((0, $hAauA.STEPS).LIVE_DOC);
        if (showConvertToPageSpotlight) keys.push((0, $hAauA.STEPS).CONVERT_TO_PAGE);
        return keys;
    }, [
        hasDismissedLiveDocTour,
        showConvertToPageSpotlight
    ]);
    const onComplete = (0, $42omo.useCallback)(()=>{
        completeSegments(stepsToComplete);
    }, [
        stepsToComplete,
        completeSegments
    ]);
    if (loading || contentQueryLoading) return {
        steps: [],
        onComplete: ()=>{},
        loading: true
    };
    if (error || contentQueryError) return {
        steps: [],
        onComplete: ()=>{},
        error: error || contentQueryError
    };
    if (!isLivePage) return {
        steps: [],
        onComplete: ()=>{}
    };
    return {
        stepsToComplete: stepsToComplete,
        steps: steps,
        onComplete: onComplete
    };
};





const $40f95027ca9f4e5a$export$782d8f736378f1c4 = ()=>{
    const { loading: loading, error: error, hasDismissedLiveDocModal: hasDismissedLiveDocModal, hasDismissedLiveDocTour: hasDismissedLiveDocTour } = (0, $hAauA.useGetModernizeChangeboardingOnboardingState)();
    const { completeLiveDocModal: completeLiveDocModal } = (0, $hAauA.useSetModernizeChangeboardingOnboardingState)();
    const onCloseModal = ()=>{
        completeLiveDocModal();
    };
    if (loading) return {
        isEligibleToSeeModal: false,
        onCloseModal: ()=>{},
        loading: true
    };
    if (error) return {
        isEligibleToSeeModal: false,
        onCloseModal: ()=>{},
        error: error
    };
    const isEligibleToSeeModal = !hasDismissedLiveDocModal && !hasDismissedLiveDocTour;
    return {
        isEligibleToSeeModal: isEligibleToSeeModal,
        onCloseModal: onCloseModal
    };
};











var $ccHMk = parcelRequire("ccHMk");


var $gj7hi = parcelRequire("gj7hi");


var $8TTLA = parcelRequire("8TTLA");

var $6xdDU = parcelRequire("6xdDU");


var $6f0Oj = parcelRequire("6f0Oj");









var $cO1el = parcelRequire("cO1el");




var $827cbe6dfdc48349$exports = {};
$827cbe6dfdc48349$exports = new URL("LiveDocModalGif-light.2404511f.gif", import.meta.url).toString();


var $209983c11ab34509$exports = {};
$209983c11ab34509$exports = new URL("LiveDocModalGif-dark.64c94d68.gif", import.meta.url).toString();









const $4090c0fefeff05ab$export$5184c2c906414fe1 = (src)=>{
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const imgSrc = colorMode === 'dark' ? src.dark : src.light;
    const [preloading, setPreloading] = (0, $42omo.useState)(true);
    (0, $42omo.useEffect)(()=>{
        const image = new Image();
        image.onload = ()=>{
            setPreloading(false);
        };
        image.onerror = ()=>{
            setPreloading(false);
        };
        image.src = imgSrc;
        // If the image has already loaded, it may not trigger the onload event
        // so we can set preloading to false immediately.
        if (image.complete) setPreloading(false);
    }, [
        imgSrc
    ]);
    return preloading;
};


const $de7882823e32407c$export$8a2273d102065255 = ()=>{
    const intl = (0, $8C5kA.default)();
    const { onCloseModal: onCloseModal } = (0, $40f95027ca9f4e5a$export$782d8f736378f1c4)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const preloadingGif = (0, $4090c0fefeff05ab$export$5184c2c906414fe1)({
        light: (0, (/*@__PURE__*/$parcel$interopDefault($827cbe6dfdc48349$exports))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($209983c11ab34509$exports)))
    });
    const closeModal = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'dismiss',
                source: 'modernizeConfluenceLiveDocModal'
            }
        }).fire();
        onCloseModal();
    }, [
        createAnalyticsEvent,
        onCloseModal
    ]);
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, preloadingGif ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        messageType: "engagement",
        messageId: "modernize-changeboarding.liveDocModal",
        onClose: closeModal,
        onOpenComplete: ()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'rendered',
                    actionSubject: 'modal',
                    actionSubjectId: 'modernizeConfluenceLiveDoc',
                    source: 'modernizeConfluenceLiveDocChangeboarding'
                }
            }).fire();
        },
        shouldCloseOnEscapePress: false,
        shouldCloseOnOverlayClick: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $de7882823e32407c$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $de7882823e32407c$var$closeContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8TTLA.CloseButton), {
        onClick: closeModal,
        testId: "close-modal-button"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($827cbe6dfdc48349$exports))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($209983c11ab34509$exports))),
        alt: ""
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $de7882823e32407c$var$textContainerStyles,
        padding: "space.500",
        paddingBlockEnd: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $de7882823e32407c$var$headingContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "medium"
    }, intl.formatMessage($de7882823e32407c$var$messages.heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        paddingBlockStart: "space.200",
        as: "p",
        xcss: $de7882823e32407c$var$bodyStyles
    }, intl.formatMessage($de7882823e32407c$var$messages.body, {
        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                as: "strong"
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        paddingBlockStart: "space.400",
        xcss: $de7882823e32407c$var$ctaContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        onClick: closeModal,
        appearance: "discovery"
    }, intl.formatMessage($de7882823e32407c$var$messages.cta))))));
};
const $de7882823e32407c$var$closeContainerStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    insetBlockStart: 'space.200',
    insetInlineEnd: 'space.200',
    backgroundColor: 'color.background.input',
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    borderRadius: 'radius.small'
});
const $de7882823e32407c$var$containerStyles = (0, $ecnYn.xcss)({
    position: 'relative',
    borderTopRightRadius: 'radius.small',
    borderTopLeftRadius: 'radius.small',
    overflow: 'hidden'
});
const $de7882823e32407c$var$textContainerStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'utility.elevation.surface.current',
    borderRadius: 'radius.small'
});
const $de7882823e32407c$var$headingContainerStyles = (0, $ecnYn.xcss)({
    textAlign: 'center'
});
const $de7882823e32407c$var$ctaContainerStyles = (0, $ecnYn.xcss)({
    textAlign: 'center'
});
const $de7882823e32407c$var$bodyStyles = (0, $ecnYn.xcss)({
    margin: '0',
    textAlign: 'center'
});
const $de7882823e32407c$var$messages = (0, $cgtv4.defineMessages)({
    heading: {
        id: "modernize-changeboarding.live-doc-modal.heading",
        defaultMessage: "Make instant edits with Live Docs"
    },
    body: {
        id: "modernize-changeboarding.live-doc-modal.body",
        defaultMessage: "Welcome to the new live docs experience, where you can work and collaborate in <strong>real time</strong> without ever having to publish."
    },
    cta: {
        id: "modernize-changeboarding.live-doc-modal.cta",
        defaultMessage: "Let\u2019s go"
    }
});



var $9wGTI = parcelRequire("9wGTI");











var $1NBp8 = parcelRequire("1NBp8");


var $gEtAQ = parcelRequire("gEtAQ");








var $3oZ9l = parcelRequire("3oZ9l");

const $d7994f6a9041e46e$export$988679de8b72dd75 = ()=>{
    const { loading: dismissedContentWrapperTourLoading, error: dismissedContentWrapperTourError, hasDismissedContentWrapperTour: hasDismissedContentWrapperTour } = (0, $hAauA.useGetModernizeChangeboardingOnboardingState)();
    const { loading: isAIFCOnboardingEligibleLoading, error: isAIFCOnboardingEligibleError, isAIFCOnbardingEligible: isAIFCOnbardingEligible } = (0, $evORK.useIsAIFCOnbardingEligible)();
    const { completeContentWrapperTour: completeContentWrapperTour } = (0, $hAauA.useSetModernizeChangeboardingOnboardingState)();
    const isLiveDoc = (0, $3jwuS.useIsCurrentPageLive)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const isLiveDocOrClassicPage = isLiveDoc || contentType === 'page';
    const isVersionHistoryPage = (0, $dPJCf.useRouteName)({
        selector: (routeName)=>routeName === (0, $1NBp8.CONTENT_HISTORY).name
    });
    const error = dismissedContentWrapperTourError || isAIFCOnboardingEligibleError;
    const isSpaceOverviewPage = (0, $gEtAQ.isSpaceOverview)();
    const shouldShowContentWrapperTour = !isAIFCOnbardingEligible && !hasDismissedContentWrapperTour && isLiveDocOrClassicPage && !isVersionHistoryPage && !isSpaceOverviewPage && (0, $9wGTI.fg)('confluence_frontend_content_wrapper');
    if (dismissedContentWrapperTourLoading || isAIFCOnboardingEligibleLoading) return {
        steps: [],
        onComplete: ()=>{},
        loading: true
    };
    if (error) return {
        steps: [],
        onComplete: ()=>{},
        error: error
    };
    if (!shouldShowContentWrapperTour) return {
        steps: [],
        onComplete: ()=>{}
    };
    return {
        stepsToComplete: [
            (0, $hAauA.STEPS).CONTENT_WRAPPER
        ],
        steps: [
            (0, $3oZ9l.Spotlights).ObjectSidebarSpotlight,
            (0, $3oZ9l.Spotlights).LastUpdatedSpotlight
        ],
        onComplete: completeContentWrapperTour
    };
};






var $917iu = parcelRequire("917iu");










// Number of days to wait before showing the modal
const $4440b4940195abef$var$THREE_WEEKS_DAYS = 21;
const $4440b4940195abef$export$70b690ea9a4c4713 = ()=>{
    const { loading: loading, error: error, hasDismissedModernizeConfluenceIpmModal: hasDismissedModernizeConfluenceIpmModal, changeboardingStartedAt: changeboardingStartedAt } = (0, $hAauA.useGetModernizeChangeboardingOnboardingState)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(null);
    const { completeModernizeConfluenceIpmModal: completeModernizeConfluenceIpmModal } = (0, $hAauA.useSetModernizeChangeboardingOnboardingState)();
    const changeboardingStartedAtLeastThreeWeeksAgo = (0, $42omo.useMemo)(()=>changeboardingStartedAt ? (0, $917iu.default)(new Date(), changeboardingStartedAt) >= $4440b4940195abef$var$THREE_WEEKS_DAYS : false, [
        changeboardingStartedAt
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isOpen === null && !loading && !error) setIsOpen(!hasDismissedModernizeConfluenceIpmModal);
    }, [
        loading,
        error,
        hasDismissedModernizeConfluenceIpmModal,
        isOpen
    ]);
    const onInteraction = (0, $42omo.useCallback)(()=>{
        if (!hasDismissedModernizeConfluenceIpmModal) completeModernizeConfluenceIpmModal();
    }, [
        hasDismissedModernizeConfluenceIpmModal,
        completeModernizeConfluenceIpmModal
    ]);
    const onDismiss = (0, $42omo.useCallback)(()=>{
        setIsOpen(false);
        onInteraction();
    }, [
        onInteraction
    ]);
    if (loading || error) return {
        loading: loading,
        error: error,
        eligible: false,
        onInteraction: ()=>{},
        onDismiss: ()=>{}
    };
    return {
        loading: false,
        error: error,
        eligible: isOpen && changeboardingStartedAtLeastThreeWeeksAgo && (0, $9wGTI.fg)('cc_onboarding_modernize_confluence_ipm_modal'),
        onInteraction: onInteraction,
        onDismiss: onDismiss
    };
};


const $e8a957bdb1cc0ab0$export$d30ff43dfc840233 = ()=>{
    const nav4GlobalSegment = (0, $9a3235c67e6e7da5$export$8cd6411811444988)();
    const nav4SpaceSegment = (0, $e2aaea8c229dc7c5$export$6d09c0166ca245c8)();
    let liveDocsSegment = (0, $a50d2ca88e96f1cb$export$c068ac5463604183)();
    const liveDocModalState = (0, $40f95027ca9f4e5a$export$782d8f736378f1c4)();
    const contentWrapperSegment = (0, $d7994f6a9041e46e$export$988679de8b72dd75)();
    const { completeSegments: completeSegments } = (0, $hAauA.useSetModernizeChangeboardingOnboardingState)();
    const modernizeModalState = (0, $4440b4940195abef$export$70b690ea9a4c4713)();
    const { hasNotSeenGlobalNav4Changeboarding: hasNotSeenGlobalNav4Changeboarding } = (0, $9a3235c67e6e7da5$export$5860d7af3254dd8d)();
    const loading = nav4GlobalSegment.loading || nav4SpaceSegment.loading || liveDocsSegment.loading || liveDocModalState.loading || contentWrapperSegment.loading || modernizeModalState.loading;
    const error = nav4GlobalSegment.error || nav4SpaceSegment.error || liveDocsSegment.error || liveDocModalState.error || contentWrapperSegment.error || modernizeModalState.error;
    let modal = null;
    if (loading) return {
        modal: modal,
        loading: true,
        steps: [],
        onComplete: ()=>{}
    };
    if (error) return {
        modal: modal,
        error: error,
        steps: [],
        onComplete: ()=>{}
    };
    if (hasNotSeenGlobalNav4Changeboarding && liveDocsSegment.steps.length > 0) // not seen global nav 4, then don't show live docs segment yet, wait til next eligible time.
    liveDocsSegment = {
        steps: [],
        loading: false,
        onComplete: ()=>{}
    };
    if (liveDocModalState.isEligibleToSeeModal && liveDocsSegment.steps.length > 0) modal = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $de7882823e32407c$export$8a2273d102065255), null);
    const steps = [];
    if (hasNotSeenGlobalNav4Changeboarding) // not seen global nav 4
    steps.push(...nav4GlobalSegment.steps, ...nav4SpaceSegment.steps, ...contentWrapperSegment.steps);
    else // seen global nav 4
    steps.push(...liveDocsSegment.steps, ...contentWrapperSegment.steps, ...nav4SpaceSegment.steps);
    if (!modal && steps.length === 0 && modernizeModalState.eligible) modal = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e1007dabeeee123f$export$9e44b2252d24bdda), {
        source: "modernize-ga-changeboarding",
        onClose: modernizeModalState.onDismiss,
        onInteraction: modernizeModalState.onInteraction
    });
    return {
        modal: modal,
        steps: steps,
        onComplete: ()=>{
            const onboardingStateKeysToComplete = [];
            [
                nav4GlobalSegment,
                nav4SpaceSegment,
                liveDocsSegment,
                contentWrapperSegment
            ].forEach(({ steps: steps, stepsToComplete: stepsToComplete })=>{
                if (steps.length > 0) onboardingStateKeysToComplete.push(...stepsToComplete ?? []);
            });
            if (onboardingStateKeysToComplete.length > 0) completeSegments(onboardingStateKeysToComplete);
        }
    };
};



var $ktziD = parcelRequire("ktziD");

const $5475281ac545e6ed$var$initialState = {
    stepIndex: 0,
    isDone: false
};
function $5475281ac545e6ed$var$reducer(state, action) {
    switch(action.type){
        case 'NEXT':
            return {
                ...state,
                stepIndex: state.stepIndex + 1
            };
        case 'BACK':
            return {
                ...state,
                stepIndex: state.stepIndex - 1
            };
        case 'COMPLETE':
            return {
                ...state,
                isDone: true
            };
        case 'RESET':
            return {
                ...state,
                ...$5475281ac545e6ed$var$initialState
            };
        default:
            return state;
    }
}
function $5475281ac545e6ed$var$isExpectedError(error) {
    return (0, $7LI3Q.isUnauthorizedError)(error) || (0, $1uFM6.isUnauthorizedError)(error);
}
const $5475281ac545e6ed$var$ModernizeChangeboardingInner = ()=>{
    const transitionId = (0, $dPJCf.useTransitionId)();
    const { modal: modal, steps: steps, loading: loading, error: error, onComplete: onComplete } = (0, $e8a957bdb1cc0ab0$export$d30ff43dfc840233)();
    const [{ stepIndex: stepIndex, isDone: isDone }, dispatch] = (0, $42omo.useReducer)($5475281ac545e6ed$var$reducer, $5475281ac545e6ed$var$initialState);
    const [messageType, setMessageType] = (0, $42omo.useState)('engagement');
    const isLast = stepIndex === steps.length - 1;
    const isFirst = stepIndex === 0;
    const onNext = (0, $42omo.useCallback)(()=>{
        if (isLast) {
            onComplete();
            dispatch({
                type: 'COMPLETE'
            });
            return;
        }
        setMessageType('transactional');
        dispatch({
            type: 'NEXT'
        });
    }, [
        isLast,
        onComplete,
        dispatch
    ]);
    const onBack = (0, $42omo.useCallback)(()=>{
        if (isFirst) return;
        dispatch({
            type: 'BACK'
        });
    }, [
        isFirst,
        dispatch
    ]);
    const onDismiss = (0, $42omo.useCallback)(()=>{
        onComplete();
        dispatch({
            type: 'COMPLETE'
        });
    }, [
        onComplete,
        dispatch
    ]);
    const TourStep = steps[stepIndex];
    (0, $42omo.useEffect)(()=>{
        // If a url change happens after the current tour is completed, then resetting it.
        // This is to ensure eligible tour for current url can be shown again, even though a different tour was completed at previous url.
        // Note: transitionId is 0 when it's the initial load. We don't want to reset the tour on initial load.
        if (transitionId > 0) dispatch({
            type: 'RESET'
        });
    }, [
        dispatch,
        transitionId
    ]);
    if (error) {
        if ($5475281ac545e6ed$var$isExpectedError(error)) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
    }
    if (loading || isDone) return null;
    if (modal) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d0oNo.WithModernizeChangeboardingActive), null, modal);
    if (!TourStep) return null;
    // if there is a modal eligible to be shown, show it instead of the tour steps
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d0oNo.WithModernizeChangeboardingActive), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fndw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(TourStep, {
        onNext: onNext,
        onBack: onBack,
        onDismiss: onDismiss,
        progress: {
            step: stepIndex + 1,
            steps: steps.length,
            isFirst: isFirst,
            isLast: isLast
        },
        messageType: messageType
    })));
};
const $5475281ac545e6ed$export$51c4358102159001 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).FLYWHEEL_ACTIVATION
})(()=>{
    const { isNewUser: isNewUser } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { isLicensed: isLicensed, isGuest: isGuest } = (0, $8Lx5S.useAccessStatus)();
    // If the user is neither licensed nor a guest, we don't show the changeboarding. This is because:
    // * Changeboarding is not applicable for anonymous users, since they can all be considered new.
    // * Onboarding state, which we use to track completion, is only available for licensed and guest users.
    if (!isLicensed && !isGuest) return null;
    // If the user is new and seeing ModernizeChangeboarding, then they joined after GA.
    // In that case we don't want to show them changeboarding, so we immediately dismiss it.
    if (isNewUser) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5475281ac545e6ed$var$ExcludeFromModernizeGAChangeboarding, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5475281ac545e6ed$var$ModernizeChangeboardingInner, null);
});
const $5475281ac545e6ed$var$ExcludeFromModernizeGAChangeboarding = ()=>{
    (0, $ktziD.useExcludeFromModernizeGAChangeboarding)();
    return null;
};
module.exports["ModernizeChangeboarding"] = $5475281ac545e6ed$export$51c4358102159001;

});

parcelRegister("7LI3Q", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $02289dc82bb02982$export$55152de1f925fd05 = (error)=>(0, $aMcHK.isStatusCodeError)(error, '401');
module.exports["isUnauthorizedError"] = $02289dc82bb02982$export$55152de1f925fd05;

});

parcelRegister("d0oNo", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $4u5NT = parcelRequire("4u5NT");


var $9wGTI = parcelRequire("9wGTI");

const $120280a361e5f451$var$initialState = {
    active: false,
    nav4GlobalChangeboardingActive: false,
    nav4SpaceSettingsChangeboardingActive: false
};
const $120280a361e5f451$var$actions = {
    setActive: (active)=>({ setState: setState })=>{
            setState({
                active: active
            });
        },
    nav4GlobalChangeboardingActive: (nav4GlobalChangeboardingActive)=>({ setState: setState })=>{
            setState({
                nav4GlobalChangeboardingActive: nav4GlobalChangeboardingActive
            });
        },
    nav4SpaceSettingsChangeboardingActive: (nav4SpaceSettingsChangeboardingActive)=>({ setState: setState })=>{
            setState({
                nav4SpaceSettingsChangeboardingActive: nav4SpaceSettingsChangeboardingActive
            });
        }
};
const $120280a361e5f451$var$ModernizeChangeboardingStore = (0, $1P1Tu.createStore)({
    initialState: $120280a361e5f451$var$initialState,
    actions: $120280a361e5f451$var$actions
});
const $120280a361e5f451$export$6f50ba18fc24265e = (0, $9zUhf.createStateHook)($120280a361e5f451$var$ModernizeChangeboardingStore, {
    selector: (state)=>state.active
});
const $120280a361e5f451$export$8f3ba153b8f179a7 = (0, $9zUhf.createStateHook)($120280a361e5f451$var$ModernizeChangeboardingStore);
const $120280a361e5f451$var$useActions = (0, $9zUhf.createActionsHook)($120280a361e5f451$var$ModernizeChangeboardingStore);
const $120280a361e5f451$var$WithModernizeChangeboardingActiveComponent = ({ children: children, setActive: setActive })=>{
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_exclude_changeboarding_from_vc')) (0, $4u5NT.abortAll)('new_interaction', 'modernize-changeboarding');
        setActive(true);
        return ()=>{
            setActive(false);
        };
    }, [
        setActive
    ]);
    return children;
};
const $120280a361e5f451$export$e6009f28c745ed28 = ({ children: children })=>{
    const { setActive: setActive } = $120280a361e5f451$var$useActions();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($120280a361e5f451$var$WithModernizeChangeboardingActiveComponent, {
        setActive: setActive
    }, children);
};
const $120280a361e5f451$export$7ebbacbc785c02ee = ({ children: children })=>{
    const { nav4GlobalChangeboardingActive: nav4GlobalChangeboardingActive } = $120280a361e5f451$var$useActions();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($120280a361e5f451$var$WithModernizeChangeboardingActiveComponent, {
        setActive: nav4GlobalChangeboardingActive
    }, children);
};
const $120280a361e5f451$export$9955699a3aa2b6fa = ({ children: children })=>{
    const { nav4SpaceSettingsChangeboardingActive: nav4SpaceSettingsChangeboardingActive } = $120280a361e5f451$var$useActions();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($120280a361e5f451$var$WithModernizeChangeboardingActiveComponent, {
        setActive: nav4SpaceSettingsChangeboardingActive
    }, children);
};
module.exports["useModernizeChangeboardingActive"] = $120280a361e5f451$export$6f50ba18fc24265e;
module.exports["useModernizeChangeboardingState"] = $120280a361e5f451$export$8f3ba153b8f179a7;
module.exports["WithModernizeChangeboardingActive"] = $120280a361e5f451$export$e6009f28c745ed28;
module.exports["WithModernizeNav4GlobalChangeboardingActive"] = $120280a361e5f451$export$7ebbacbc785c02ee;
module.exports["WithModernizeNav4SpaceSettingsChangeboardingActive"] = $120280a361e5f451$export$9955699a3aa2b6fa;

});

parcelRegister("hpVzJ", function(module, exports) {

let $cae16ebd4227330c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cae16ebd4227330c$var$load("hhss7"),
    $cae16ebd4227330c$var$load("iZkNL")
]).then(()=>parcelRequire('6vjKX'));

});

parcelRegister("evORK", function(module, exports) {

var $dlSEv = parcelRequire("dlSEv");


var $9wGTI = parcelRequire("9wGTI");


var $kAcNG = parcelRequire("kAcNG");


var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");


var $gqypm = parcelRequire("gqypm");

const $eeeb74b654b378be$var$CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';
const $eeeb74b654b378be$export$c71507e40f69e111 = ()=>{
    const { isRovoLLMEnabled: isRovoLLMEnabled, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const { data: siteUserPersonalizationData, loading: siteUserPersonalizationLoading, error: siteUserPersonalizationError } = (0, $gqypm.useExperimentalSiteUserPersonalization)({
        variables: {
            cloudId: cloudId,
            userId: userId
        },
        skip: !userId || !cloudId || !isLicensed || !isRovoLLMEnabled || !(0, $9wGTI.fg)('aifc_onboarding_killswitch') || !(0, $9wGTI.fg)('aifc_create_enabled')
    });
    const siteUserPersonalizationAttributes = siteUserPersonalizationData?.experimentalSiteUserPersonalization?.attributes;
    const confluenceFirstActive = siteUserPersonalizationAttributes?.find(({ name: name })=>name === $eeeb74b654b378be$var$CONFLUENCE_FIRST_ACTIVE_TRAIT)?.value;
    const { attributes: sitePersonalizationAttributes, loading: sitePersonalizationLoading, error: sitePersonalizationError } = (0, $kAcNG.useSitePersonalizationQuery)({
        cloudId: cloudId,
        skip: !cloudId || !isLicensed || !isRovoLLMEnabled || !(0, $9wGTI.fg)('aifc_onboarding_killswitch') || !(0, $9wGTI.fg)('aifc_create_enabled')
    });
    const AIFCBetaEnrolledDateTime = sitePersonalizationAttributes?.find(({ name: name })=>name === 'confluence_aifc_enabled_datetime')?.value;
    const isExistingUserBeforeAIFCBetaEnrolled = !!confluenceFirstActive && !!AIFCBetaEnrolledDateTime && (0, $dlSEv.default)(new Date(confluenceFirstActive), new Date(AIFCBetaEnrolledDateTime));
    if (sitePersonalizationError || sitePersonalizationLoading || siteUserPersonalizationError || siteUserPersonalizationLoading || !(0, $9wGTI.fg)('aifc_onboarding_killswitch') || !(0, $9wGTI.fg)('aifc_create_enabled')) return {
        isAIFCOnbardingEligible: false,
        error: sitePersonalizationError || siteUserPersonalizationError,
        loading: sitePersonalizationLoading || siteUserPersonalizationLoading
    };
    return {
        isAIFCOnbardingEligible: isExistingUserBeforeAIFCBetaEnrolled,
        loading: false
    };
};
module.exports["useIsAIFCOnbardingEligible"] = $eeeb74b654b378be$export$c71507e40f69e111;

});

parcelRegister("dlSEv", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b87a15bb5e36b12$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $9b87a15bb5e36b12$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var dateToCompare = (0, $egXhZ.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});

parcelRegister("kAcNG", function(module, exports) {

var $8Lx5S = parcelRequire("8Lx5S");


var $1uFM6 = parcelRequire("1uFM6");


var $aMcHK = parcelRequire("aMcHK");


var $hcDKy = parcelRequire("hcDKy");

let $a3e54b7319a42934$export$98a405b08ebbac37 = false;
const $a3e54b7319a42934$export$3cfde1d6c626a865 = ({ cloudId: cloudId, skip: skip, fetchPolicy: fetchPolicy })=>{
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const skipOptions = skip || !isLicensed || $a3e54b7319a42934$export$98a405b08ebbac37 || // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    Boolean(undefined); // SitePersonalizationQuery isn't preloaded and can be skipped during SSR to avoid unnecessary requests
    const { data: data, loading: loading, error: error } = (0, $hcDKy.useExperimentalSitePersonalizationQuery)({
        variables: {
            cloudId: cloudId
        },
        fetchPolicy: fetchPolicy || 'cache-first',
        skip: skipOptions,
        onError (apolloError) {
            $a3e54b7319a42934$export$98a405b08ebbac37 = apolloError?.graphQLErrors?.some((graphQLError)=>(0, $aMcHK.isStatusCodeError)(graphQLError, '401') || (0, $1uFM6.isUnauthorizedError)(graphQLError));
        }
    });
    const attributes = data?.experimentalSitePersonalization?.attributes || [];
    return {
        loading: loading,
        error: error,
        attributes: attributes
    };
};
module.exports["useSitePersonalizationQuery"] = $a3e54b7319a42934$export$3cfde1d6c626a865;

});

parcelRegister("hcDKy", function(module, exports) {

var $dK51B = parcelRequire("dK51B");


var $CIjCq = parcelRequire("CIjCq");

const $c7a26f042941282d$export$f9ec68434a742b9f = ({ skip: skip, onError: onError, variables: variables, fetchPolicy: fetchPolicy })=>{
    return (0, $dK51B.useExperimentalQuery)({
        url: ({ cloudId: cloudId })=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`,
        method: 'GET',
        parseResult: (json)=>({
                experimentalSitePersonalization: {
                    attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(json.attributes)
                }
            }),
        skip: skip,
        onError: onError,
        variables: variables,
        fetchPolicy: fetchPolicy
    });
};
module.exports["useExperimentalSitePersonalizationQuery"] = $c7a26f042941282d$export$f9ec68434a742b9f;

});

parcelRegister("CIjCq", function(module, exports) {
/**
 * The TAP delivery API returns mixed types (boolean, number, string), but the
 * previous experimental GraphQL schema defined all values as String!, causing
 * automatic coercion. When bypassing GraphQL via useExperimentalQuery, we need
 * to manually coerce to maintain the same behavior consumer code expects.
 */ function $3c8babd51a2343c1$export$1660902c4f08468b(attributes) {
    if (!attributes) return [];
    return attributes.map((attr)=>({
            ...attr,
            value: String(attr.value)
        }));
}
module.exports["stringifyPersonalizationAttributes"] = $3c8babd51a2343c1$export$1660902c4f08468b;

});

parcelRegister("gqypm", function(module, exports) {

var $dK51B = parcelRequire("dK51B");


var $CIjCq = parcelRequire("CIjCq");

const $a585c4c0c1029461$export$650aef70f4433205 = ({ variables: variables, skip: skip })=>{
    return (0, $dK51B.useExperimentalQuery)({
        url: ({ cloudId: cloudId, userId: userId })=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`,
        method: 'GET',
        variables: variables,
        parseResult: (json)=>({
                experimentalSiteUserPersonalization: {
                    attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(json.attributes)
                }
            }),
        skip: skip
    });
};
module.exports["useExperimentalSiteUserPersonalization"] = $a585c4c0c1029461$export$650aef70f4433205;

});

parcelRegister("hAauA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cFEpk = parcelRequire("cFEpk");

var $Jcg3W = parcelRequire("Jcg3W");

var $da71s = parcelRequire("da71s");


var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");

var $9DBk6 = parcelRequire("9DBk6");


var $8Lx5S = parcelRequire("8Lx5S");


var $7Sm4c = parcelRequire("7Sm4c");

const $18c0ce8e6ce7aa7a$export$bc130f10168df871 = (values, defaultDate)=>{
    // Only keep expected dismissed values: either valid ISO datetimes,
    // or the legacy value `true` which we replace with a default date
    const validDates = values.map((value)=>value === true ? defaultDate : value).filter((value)=>typeof value === 'string').map((value)=>(0, $da71s.default)(value)).filter((0, $cFEpk.default));
    return validDates.length === 0 ? undefined : (0, $Jcg3W.default)(validDates);
};
const $18c0ce8e6ce7aa7a$var$DEFAULT_CHANGEBOARDING_DISMISSED_DATE = '2025-06-09T00:00:00.000Z';
var $18c0ce8e6ce7aa7a$export$6836fb99d2ec00dc = /*#__PURE__*/ function(STEPS) {
    STEPS["NAV_4_GLOBAL"] = "nav4Global";
    STEPS["NAV_4_SPACE"] = "nav4Space";
    STEPS["LIVE_DOC"] = "liveDoc";
    STEPS["CONVERT_TO_PAGE"] = "convertToPage";
    STEPS["CONTENT_WRAPPER"] = "contentWrapper";
    return STEPS;
}({});
const $18c0ce8e6ce7aa7a$export$ea73d43a15ad8a09 = {
    ["nav4Global"]: (0, $dBcar.IS_NAV_4_GLOBAL_SPOTLIGHT_DISMISSED),
    ["nav4Space"]: (0, $dBcar.IS_NAV_4_SPACE_TOUR_DISMISSED),
    ["liveDoc"]: (0, $9DBk6.LIVE_DOC_CHANGEBOARDING_ONBOARDING_STATE_KEYS).hasDismissedLiveDocTour,
    ["convertToPage"]: (0, $9DBk6.LIVE_DOC_CHANGEBOARDING_ONBOARDING_STATE_KEYS).hasDismissedConvertToPageSpotlight,
    ["contentWrapper"]: (0, $9DBk6.LIVE_DOC_CHANGEBOARDING_ONBOARDING_STATE_KEYS).hasDismissedContentWrapperTour
};
const $18c0ce8e6ce7aa7a$export$1fd867888be3cc89 = ()=>{
    const { isLicensed: isLicensed, isGuest: isGuest } = (0, $8Lx5S.useAccessStatus)();
    const accessError = isLicensed || isGuest ? null : new Error('Only licensed or guest users can retrieve onboarding state');
    if (accessError) (0, $7Sm4c.markErrorAsHandled)(accessError);
    const { data: data, loading: loading, error: error } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.IS_NAV_4_GLOBAL_SPOTLIGHT_DISMISSED),
        (0, $dBcar.IS_NAV_4_SPACE_TOUR_DISMISSED),
        ...Object.values((0, $9DBk6.LIVE_DOC_CHANGEBOARDING_ONBOARDING_STATE_KEYS)),
        ...Object.values((0, $dBcar.MODERNIZE_CONFLUENCE_IPM_MODAL))
    ]);
    const { isNav4GlobalSpotlightDismissed: isNav4GlobalSpotlightDismissed, isNav4SpaceTourDismissed: isNav4SpaceTourDismissed, hasDismissedIntroSpotlight: hasDismissedIntroSpotlight, hasDismissedLiveDocTour: hasDismissedLiveDocTour, hasDismissedLiveDocModal: hasDismissedLiveDocModal, hasDismissedContentWrapperTour: hasDismissedContentWrapperTour, hasDismissedAiButtonTour: hasDismissedAiButtonTour, hasDismissedConvertToPageSpotlight: hasDismissedConvertToPageSpotlight, hasDismissedModernizeConfluenceIpmModal: hasDismissedModernizeConfluenceIpmModal } = (0, $ivb8S.deserializeState)(data);
    const changeboardingStartedAt = (0, $42omo.useMemo)(()=>{
        return $18c0ce8e6ce7aa7a$export$bc130f10168df871([
            isNav4GlobalSpotlightDismissed,
            isNav4SpaceTourDismissed,
            hasDismissedIntroSpotlight,
            hasDismissedLiveDocTour,
            hasDismissedLiveDocModal,
            hasDismissedContentWrapperTour,
            hasDismissedConvertToPageSpotlight
        ], $18c0ce8e6ce7aa7a$var$DEFAULT_CHANGEBOARDING_DISMISSED_DATE);
    }, [
        isNav4GlobalSpotlightDismissed,
        isNav4SpaceTourDismissed,
        hasDismissedIntroSpotlight,
        hasDismissedLiveDocTour,
        hasDismissedLiveDocModal,
        hasDismissedContentWrapperTour,
        hasDismissedConvertToPageSpotlight
    ]);
    return {
        isNav4GlobalSpotlightDismissed: isNav4GlobalSpotlightDismissed,
        isNav4SpaceTourDismissed: isNav4SpaceTourDismissed,
        hasDismissedIntroSpotlight: hasDismissedIntroSpotlight,
        hasDismissedLiveDocTour: hasDismissedLiveDocTour,
        hasDismissedLiveDocModal: hasDismissedLiveDocModal,
        hasDismissedContentWrapperTour: hasDismissedContentWrapperTour,
        hasDismissedAiButtonTour: hasDismissedAiButtonTour,
        hasDismissedConvertToPageSpotlight: hasDismissedConvertToPageSpotlight,
        hasDismissedModernizeConfluenceIpmModal: hasDismissedModernizeConfluenceIpmModal,
        changeboardingStartedAt: changeboardingStartedAt,
        loading: loading,
        error: error || accessError
    };
};
const $18c0ce8e6ce7aa7a$export$f3de357f3d6ca0df = ()=>{
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const completeNav4GlobalSpotlight = (0, $42omo.useCallback)(()=>{
        setOnboardingState({
            key: (0, $dBcar.IS_NAV_4_GLOBAL_SPOTLIGHT_DISMISSED),
            value: new Date().toISOString()
        });
    }, [
        setOnboardingState
    ]);
    const completeNav4SpaceTour = (0, $42omo.useCallback)(()=>{
        setOnboardingState({
            key: (0, $dBcar.IS_NAV_4_SPACE_TOUR_DISMISSED),
            value: new Date().toISOString()
        });
    }, [
        setOnboardingState
    ]);
    const completeContentWrapperTour = (0, $42omo.useCallback)(()=>{
        setOnboardingState({
            key: (0, $9DBk6.LIVE_DOC_CHANGEBOARDING_ONBOARDING_STATE_KEYS).hasDismissedContentWrapperTour,
            value: new Date().toISOString()
        });
    }, [
        setOnboardingState
    ]);
    const completeLiveDocModal = (0, $42omo.useCallback)(()=>{
        setOnboardingState({
            key: (0, $9DBk6.LIVE_DOC_CHANGEBOARDING_ONBOARDING_STATE_KEYS).hasDismissedLiveDocModal,
            value: new Date().toISOString()
        });
    }, [
        setOnboardingState
    ]);
    const completeModernizeConfluenceIpmModal = (0, $42omo.useCallback)(()=>{
        setOnboardingState({
            key: (0, $dBcar.MODERNIZE_CONFLUENCE_IPM_MODAL).HAS_DISMISSED_MODAL,
            value: new Date().toISOString()
        });
    }, [
        setOnboardingState
    ]);
    const completeLiveDocTour = (0, $42omo.useCallback)(()=>{
        setOnboardingState({
            key: (0, $9DBk6.LIVE_DOC_CHANGEBOARDING_ONBOARDING_STATE_KEYS).hasDismissedLiveDocTour,
            value: new Date().toISOString()
        });
    }, [
        setOnboardingState
    ]);
    const completeConvertToPageSpotlight = (0, $42omo.useCallback)(()=>{
        setOnboardingState({
            key: $18c0ce8e6ce7aa7a$export$ea73d43a15ad8a09["convertToPage"],
            value: new Date().toISOString()
        });
    }, [
        setOnboardingState
    ]);
    const completeSegments = (0, $42omo.useCallback)((steps, options = {})=>{
        const onboardingStateUpdates = [
            ...options.dismissIpmModal ? [
                {
                    key: (0, $dBcar.MODERNIZE_CONFLUENCE_IPM_MODAL).HAS_DISMISSED_MODAL,
                    value: new Date().toISOString()
                },
                {
                    key: (0, $dBcar.MODERNIZE_CONFLUENCE_IPM_MODAL).HAS_DISMISSED_BANNER,
                    value: new Date().toISOString()
                }
            ] : [],
            ...steps.map((step)=>({
                    key: $18c0ce8e6ce7aa7a$export$ea73d43a15ad8a09[step],
                    value: new Date().toISOString()
                }))
        ];
        if (onboardingStateUpdates.length > 0) setOnboardingState(onboardingStateUpdates);
    }, [
        setOnboardingState
    ]);
    return {
        completeNav4GlobalSpotlight: completeNav4GlobalSpotlight,
        completeNav4SpaceTour: completeNav4SpaceTour,
        completeLiveDocModal: completeLiveDocModal,
        completeLiveDocTour: completeLiveDocTour,
        completeContentWrapperTour: completeContentWrapperTour,
        completeConvertToPageSpotlight: completeConvertToPageSpotlight,
        completeSegments: completeSegments,
        completeModernizeConfluenceIpmModal: completeModernizeConfluenceIpmModal
    };
};
module.exports["STEPS"] = $18c0ce8e6ce7aa7a$export$6836fb99d2ec00dc;
module.exports["useGetModernizeChangeboardingOnboardingState"] = $18c0ce8e6ce7aa7a$export$1fd867888be3cc89;
module.exports["useSetModernizeChangeboardingOnboardingState"] = $18c0ce8e6ce7aa7a$export$f3de357f3d6ca0df;

});

parcelRegister("Jcg3W", function(module, exports) {
$parcel$export(module.exports, "default", () => $087db648319af5a6$export$2e2bcd8739ae039);

var $da6O1 = parcelRequire("da6O1");


var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $087db648319af5a6$export$2e2bcd8739ae039(dirtyDatesArray) {
    (0, $b5utg.default)(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') datesArray = dirtyDatesArray;
    else if ((0, $da6O1.default)(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, $egXhZ.default)(dirtyDate);
        if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) result = currentDate;
    });
    return result || new Date(NaN);
}

});

parcelRegister("da71s", function(module, exports) {
$parcel$export(module.exports, "default", () => $9951a80eb1f73a12$export$2e2bcd8739ae039);

var $jx0NF = parcelRequire("jx0NF");


var $b5utg = parcelRequire("b5utg");


var $jZ39j = parcelRequire("jZ39j");

function $9951a80eb1f73a12$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $b5utg.default)(1, arguments);
    var additionalDigits = (0, $jZ39j.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $9951a80eb1f73a12$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $9951a80eb1f73a12$var$parseYear(dateStrings.date, additionalDigits);
        date = $9951a80eb1f73a12$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $9951a80eb1f73a12$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $9951a80eb1f73a12$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $9951a80eb1f73a12$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $9951a80eb1f73a12$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $9951a80eb1f73a12$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $9951a80eb1f73a12$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $9951a80eb1f73a12$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($9951a80eb1f73a12$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($9951a80eb1f73a12$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($9951a80eb1f73a12$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $9951a80eb1f73a12$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $9951a80eb1f73a12$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $9951a80eb1f73a12$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($9951a80eb1f73a12$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $9951a80eb1f73a12$var$parseDateUnit(captures[1]);
    var month = $9951a80eb1f73a12$var$parseDateUnit(captures[2]) - 1;
    var day = $9951a80eb1f73a12$var$parseDateUnit(captures[3]);
    var week = $9951a80eb1f73a12$var$parseDateUnit(captures[4]);
    var dayOfWeek = $9951a80eb1f73a12$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$9951a80eb1f73a12$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $9951a80eb1f73a12$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$9951a80eb1f73a12$var$validateDate(year, month, day) || !$9951a80eb1f73a12$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $9951a80eb1f73a12$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $9951a80eb1f73a12$var$parseTime(timeString) {
    var captures = timeString.match($9951a80eb1f73a12$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $9951a80eb1f73a12$var$parseTimeUnit(captures[1]);
    var minutes = $9951a80eb1f73a12$var$parseTimeUnit(captures[2]);
    var seconds = $9951a80eb1f73a12$var$parseTimeUnit(captures[3]);
    if (!$9951a80eb1f73a12$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute) + seconds * 1000;
}
function $9951a80eb1f73a12$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $9951a80eb1f73a12$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($9951a80eb1f73a12$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$9951a80eb1f73a12$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute));
}
function $9951a80eb1f73a12$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $9951a80eb1f73a12$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $9951a80eb1f73a12$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $9951a80eb1f73a12$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($9951a80eb1f73a12$var$daysInMonths[month] || ($9951a80eb1f73a12$var$isLeapYearIndex(year) ? 29 : 28));
}
function $9951a80eb1f73a12$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($9951a80eb1f73a12$var$isLeapYearIndex(year) ? 366 : 365);
}
function $9951a80eb1f73a12$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $9951a80eb1f73a12$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $9951a80eb1f73a12$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("jx0NF", function(module, exports) {
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $e381b83e7c88ee8c$export$dfd9b671c89acc8e = 7;
var $e381b83e7c88ee8c$export$3913210603d8e9ae = 365.2425;
var $e381b83e7c88ee8c$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $e381b83e7c88ee8c$export$91246f0b9bd9beff = 60000;
var $e381b83e7c88ee8c$export$7f72910d6dfd237a = 3600000;
var $e381b83e7c88ee8c$export$397c2d5776aa9055 = 1000;
var $e381b83e7c88ee8c$export$4dec998e48f9c246 = -$e381b83e7c88ee8c$export$81caae6e1cc7a622;
var $e381b83e7c88ee8c$export$f2f5ae5a8e2d8f9f = 60;
var $e381b83e7c88ee8c$export$3c58128db900d44e = 3;
var $e381b83e7c88ee8c$export$80d7e435f744f319 = 12;
var $e381b83e7c88ee8c$export$4db7641526e3241f = 4;
var $e381b83e7c88ee8c$export$698aec755e92c695 = 3600;
var $e381b83e7c88ee8c$export$a77c1a7ebebe2a5a = 60;
var $e381b83e7c88ee8c$export$815a9362476d2fe3 = $e381b83e7c88ee8c$export$698aec755e92c695 * 24;
var $e381b83e7c88ee8c$export$34804a017b31e2fe = $e381b83e7c88ee8c$export$815a9362476d2fe3 * 7;
var $e381b83e7c88ee8c$export$7271e9e3478110d1 = $e381b83e7c88ee8c$export$815a9362476d2fe3 * $e381b83e7c88ee8c$export$3913210603d8e9ae;
var $e381b83e7c88ee8c$export$8e6600bbdee7dabb = $e381b83e7c88ee8c$export$7271e9e3478110d1 / 12;
var $e381b83e7c88ee8c$export$be1dccf2de902d31 = $e381b83e7c88ee8c$export$8e6600bbdee7dabb * 3;
module.exports["millisecondsInMinute"] = $e381b83e7c88ee8c$export$91246f0b9bd9beff;
module.exports["millisecondsInHour"] = $e381b83e7c88ee8c$export$7f72910d6dfd237a;
module.exports["millisecondsInSecond"] = $e381b83e7c88ee8c$export$397c2d5776aa9055;

});

parcelRegister("7S7nY", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $gqypm = parcelRequire("gqypm");

const $63574695e209bf34$export$a942c00307626545 = ()=>{
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const { loading: loading, data: data, error: error } = (0, $gqypm.useExperimentalSiteUserPersonalization)({
        variables: {
            cloudId: cloudId,
            userId: userId ?? ''
        },
        skip: !userId
    });
    if (!data) return {
        isInNav4Audience: false,
        hasDismissedNav4ChangeboardingViaEP: false,
        loading: loading,
        error: error
    };
    let isInNav4Audience = false;
    let hasDismissedNav4ChangeboardingViaEP = false;
    for (const { name: name, value: value } of data.experimentalSiteUserPersonalization?.attributes ?? []){
        if (name === 'segment_confluence_nav_4_changeboarding_cloned_siteuser') isInNav4Audience = value === 'true';
        else if (name === 'completed_cc-nav-4-changeboarding-prod') hasDismissedNav4ChangeboardingViaEP = Boolean(value);
    }
    return {
        isInNav4Audience: isInNav4Audience,
        hasDismissedNav4ChangeboardingViaEP: hasDismissedNav4ChangeboardingViaEP,
        loading: loading,
        error: error
    };
};
module.exports["useModernizeChangeboardingTapTraits"] = $63574695e209bf34$export$a942c00307626545;

});

parcelRegister("gj7hi", function(module, exports) {
$parcel$export(module.exports, "default", () => $df095e8eefdd8265$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $hWSc7 = parcelRequire("hWSc7");


var $cOrQJ = parcelRequire("cOrQJ");

const $df095e8eefdd8265$var$baseImageStyles = null; /**
                               * __Image__
                               *
                               * This component can be used interchangeably with the native `img` element. It includes additional functionality, such as theme support.
                               *
                               * - [Examples](https://atlassian.design/components/image/examples)
                               * - [Code](https://atlassian.design/components/image/code)
                               * - [Usage](https://atlassian.design/components/image/usage)
                               */ 
function $df095e8eefdd8265$export$2e2bcd8739ae039({ src: src, srcDark: srcDark, alt: alt, testId: testId, className: className, ...props }) {
    const imgRef = (0, $42omo.useRef)(null);
    const providedColorMode = (0, $hWSc7.UNSAFE_useColorModeForMigration)();
    const { colorMode: observedColorMode } = (0, $cOrQJ.default)();
    const colorMode = providedColorMode || observedColorMode;
    (0, $42omo.useEffect)(()=>{
        if (imgRef === null || imgRef.current === null) return;
        if (srcDark && colorMode === 'dark') imgRef.current.src = srcDark;
        else if (src) imgRef.current.src = src;
    }, [
        src,
        srcDark,
        colorMode
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("img", {
        alt: alt,
        "data-testid": testId,
        src: src,
        className: (0, $gMc0m.default)([
            "_p12f1osq _4t3i1wug",
            className
        ]),
        ref: imgRef,
        ...props
    });
}

});

parcelRegister("hWSc7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1aJUB = parcelRequire("1aJUB");

function $89c9339d073609a7$export$ce91654eb9fea460() {
    const value = (0, $42omo.useContext)((0, $1aJUB.ColorModeContext));
    return value;
}
module.exports["UNSAFE_useColorModeForMigration"] = $89c9339d073609a7$export$ce91654eb9fea460;

});

parcelRegister("ktziD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $hAauA = parcelRequire("hAauA");

const $4d9f5979af6eaf98$export$47bcbeae4ba4de7 = (skip = false)=>{
    const { completeSegments: completeSegments } = (0, $hAauA.useSetModernizeChangeboardingOnboardingState)();
    const hasCompleted = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (skip || !(0, $9wGTI.fg)('cc_modernize_ga_changeboarding') || hasCompleted.current) return;
        completeSegments([
            (0, $hAauA.STEPS).NAV_4_GLOBAL,
            (0, $hAauA.STEPS).NAV_4_SPACE,
            (0, $hAauA.STEPS).LIVE_DOC,
            (0, $hAauA.STEPS).CONVERT_TO_PAGE,
            (0, $hAauA.STEPS).CONTENT_WRAPPER
        ], {
            dismissIpmModal: true
        });
        hasCompleted.current = true;
    }, [
        completeSegments,
        skip
    ]);
};
module.exports["useExcludeFromModernizeGAChangeboarding"] = $4d9f5979af6eaf98$export$47bcbeae4ba4de7;

});

parcelRegister("c54hr", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $367766f6f044c46b$var$initialState = {
    isMenuOpen: false,
    isCloseMenuDisabled: false
};
const $367766f6f044c46b$var$actions = {
    setIsMenuOpen: (isMenuOpen)=>({ setState: setState })=>{
            setState({
                isMenuOpen: isMenuOpen
            });
        },
    setIsCloseMenuDisabled: (isCloseMenuDisabled)=>({ setState: setState })=>{
            setState({
                isCloseMenuDisabled: isCloseMenuDisabled
            });
        }
};
const $367766f6f044c46b$var$Store = (0, $1P1Tu.createStore)({
    initialState: $367766f6f044c46b$var$initialState,
    actions: $367766f6f044c46b$var$actions,
    name: 'more-actions-menu-store'
});
const $367766f6f044c46b$export$14d00db016c2b3ef = (0, $9zUhf.createStateHook)($367766f6f044c46b$var$Store);
const $367766f6f044c46b$export$1f1f8c486fa8a1cb = (0, $9zUhf.createActionsHook)($367766f6f044c46b$var$Store);
module.exports["useMoreActionsMenuState"] = $367766f6f044c46b$export$14d00db016c2b3ef;
module.exports["useMoreActionsMenuActions"] = $367766f6f044c46b$export$1f1f8c486fa8a1cb;

});


//# sourceMappingURL=ModernizeChangeboarding.e70dec7f.js.map
